<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="currentColor" />
    <path
      d="M14.8 13.4C16.5673 13.4 18 11.9673 18 10.2C18 8.43269 16.5673 7 14.8 7C13.0327 7 11.6 8.43269 11.6 10.2C11.6 11.9673 13.0327 13.4 14.8 13.4Z"
      fill="white" />
    <path
      d="M19.5931 20.1334L18.8667 15.5979C18.7851 14.8012 18.1003 14.2002 17.2764 14.2002H16.3996C16.1868 14.2002 15.9836 14.2825 15.8332 14.4269L14.7997 15.4301L13.7661 14.4269C13.6158 14.2825 13.4126 14.2002 13.1998 14.2002H12.3246C11.4991 14.2002 10.8143 14.8012 10.7343 15.5777L10.0063 20.135C9.97753 20.3555 10.0479 20.5791 10.1999 20.7453C10.3519 20.913 10.5695 21.0093 10.7999 21.0093H11.6638L12.3326 21.6025C12.8566 22.6325 13.099 23.0002 13.9245 23.0002H15.6765C16.502 23.0002 16.9109 22.6325 17.27 21.5886L17.9371 21.0093H18.7995C19.0299 21.0093 19.2475 20.913 19.3995 20.7453C19.5531 20.5791 19.6235 20.3555 19.5931 20.1334Z"
      fill="white" />
  </svg>
</template>

<script>
export default {
  name: 'AccountFilled',
};
</script>
